import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { InvDailyWasteSetting } from "../inv-daily-waste.model";
import { Observable } from "rxjs";

@Component({
  selector: "ngx-inv-daily-waste-setting",
  templateUrl: "./inv-daily-waste-setting.component.html",
  styleUrls: ["./inv-daily-waste-setting.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvDailyWasteSettingComponent extends BaseFormComponent<InvDailyWasteSetting> {
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }

  async ngOnInit() {
    this.apiName = "InvDailyWasteFormSetting";
    this.label = this.translate("ClientApp.FrontOffice.Inv.DailyWaste.Settings");
    this.customColumnInfoApi = "InvDailyWasteFormSetting/GetFormColumnInfo";
    super.ngOnInit();
  }

  setdefault(): void {
    if (!this.isMultiBranch) {
      this.formGroup.get("InvBranchId")?.enable();
      this.cd.markForCheck();
    } else {
      this.setValue("InvBranchId", this.accountService.authService.currentBranch?.Id);
      this.cd.markForCheck();
    }
  }

  addControl() {
    this.setValue("InvBranchId", this.model.BranchId);
    this.setValue("InvVoucherId", this.model.BranchId);
    this.setValue("InvWareHouseId", this.model.BranchId);
    if (!this.isMultiBranch) {
      this.formGroup.get("InvBranchId")?.enable();
    } else {
      this.setValue("InvBranchId", this.accountService.authService.currentBranch?.Id);
    }
    this.cd.markForCheck();
  }

  override canDeactivate(): boolean | Observable<boolean> {
    this.closeForm(true);
    return true;
  }
}
